import React, { useState, useLayoutEffect } from "react";
import Layout from "layouts/layout";
import { AcceptedPayments } from "constants/images";
import Toggle from "components/toggle/toggle";
import PlanCardItem from "components/plan/plan-card";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useHistory } from "react-router-dom";
import { randomExtension } from "utils/utils";
import { PLANS } from "utils/constant";
import { BASE_URL } from "configs/api";
import CurrencySelector from "components/select/currency-select";
import { ENV } from "configs/env";
import { STRIPE_AUD_PREMIUM_LIFETIME, PAYPAL_AUD_PREMIUM_LIFETIME } from "configs/subscription";
import { toast } from "react-hot-toast";

export default function PlanPage() {
  const { http, localstorage } = global.services;
  const history = useHistory();

  const [billing, setBilling] = useState(ENV == "prod" ? "yearly" : "weekly");
  const [currencyPrice, setCurrency] = useState("aud_price");

  const termOption = ENV == "prod" ? ['monthly', 'yearly','lifetime'] : ['daily', 'weekly','lifetime'];

  const extension = randomExtension();

  const checkout = async (plan, price_id, currency = 'aud') => {
    try {
      const { data } = await http.post("public/subscribes", {
        plan: plan,
        price_id: price_id,
        currency: currency,
        success_url: `${BASE_URL}/subscription/success`,
        cancel_url: `${BASE_URL}/plans`,
      });

      window.location.href = data.url;
    } catch (err) {
      console.log(err);
    }
  };

  const paypalCheckout = async (plan, plan_id, currency = 'aud') => {
    try {
      const { data } = await http.post("public/paypal/subscribes", {
        plan: plan,
        plan_id: plan_id,
        currency: currency,
        success_url: `${BASE_URL}/subscription/success`,
        cancel_url: `${BASE_URL}/plans`,
      });

      window.location.href = data.url;
    } catch (err) {
      console.log(err);
    }
  };

  const selectPlan = async (plan, pm) => {
    const userData = localstorage.get("user_data");
    console.log(plan[currencyPrice])
    if (userData.value) {
      const { user, profile } = JSON.parse(userData.value);
      if (plan.plan === "Free Account") {
        history.push(`/${user.username}-${extension}/profile/${profile.id}`);
      }
      else if (plan.plan === "Premium Lifetime") {
        if (pm === "paypal") {
          paypalCheckoutLiftime(plan.plan, plan[currencyPrice].plan_id, plan[currencyPrice].currency);
        } else {
          stripeCheckoutLifetime(plan.plan, plan[currencyPrice].price_id, plan[currencyPrice].currency);
        }
      }
      else {
        if (pm === "paypal") {
          paypalCheckout(plan.plan, plan[currencyPrice].plan_id, plan[currencyPrice].currency);
        } else {
          checkout(plan.plan, plan[currencyPrice].price_id, plan[currencyPrice].currency);
        }
      }
    } else {
      history.push("/login");
    }
  };

    const stripeCheckoutLifetime = async () => {
      // Use existing public/subscribes endpoint but pass a lifetime plan id
      let userData = JSON.parse(localStorage.getItem('user_data')) || null;
      try {
        const { data } = await http.post("public/signup-subscribes", {
          plan: "Premium Lifetime",
          currency: "aud",
          price_id: STRIPE_AUD_PREMIUM_LIFETIME,
          success_url: `${BASE_URL}/subscription/success`,
          cancel_url: `${BASE_URL}/plans`,
          email: userData.user.email
        });
        window.location.href = data.url;
      } catch (err) {
        console.log(err);
        toast.error(err?.data?.message || err.message);
      }
    };

    const paypalCheckoutLiftime = async () => {
      try {
        let userData = JSON.parse(localStorage.getItem('user_data')) || null;
        const { data } = await http.post("public/paypal/signup-subscribes", {
          plan: "Premium Lifetime",
          plan_id: PAYPAL_AUD_PREMIUM_LIFETIME,
          currency: "aud",
          email: userData.user.email,
          success_url: `${BASE_URL}/subscription/success`,
          cancel_url: `${BASE_URL}/plans`,
        });
        window.location.href = data.url;
      } catch (err) {
        console.log(err);
        toast.error(err?.data?.message || err.message);
      }
    };

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const monthTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".plan-breadcrumbs",
        start: "top center",
        endTrigger: ".terms",
        toggleActions: "play reverse play reset",
      },
    });
    monthTl.fromTo(".monthly", { x: -50, opacity: 0 }, { x: 0, opacity: 1 });
    const yearlyTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".plan-breadcrumbs",
        start: "top center",
        endTrigger: ".terms",
        toggleActions: "play reverse play reset",
      },
    });
    yearlyTl.fromTo(".yearly", { x: 50, opacity: 0 }, { x: 0, opacity: 1 });
    const planToggleTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".plan-breadcrumbs",
        start: "top center",
        endTrigger: ".terms",
        toggleActions: "play reverse play reset",
      },
    });
    planToggleTl.fromTo(
      ".plan-toggle",
      { y: -20, opacity: 0 },
      { y: 0, opacity: 1 }
    );
    /** card plan */
    gsap.fromTo(
      ".plan-card-item",
      { scale: 0, opacity: 0 },
      { scale: 1, opacity: 1 }
    );
    gsap.fromTo(
      ".payment-heading",
      { y: -20, opacity: 0 },
      { y: 0, opacity: 1 }
    );
    gsap.fromTo(".payment-items", { y: 20, opacity: 0 }, { y: 0, opacity: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Layout
      title="Plans"
      breadscrumbs={{
        title: "Plans Page",
        subtitle: "",
        showBanner: true,
      }}>
      <div className="website-page-wrapper py-17">
        {/* plans */}
        <div className="w-full overflow-hidden">
          {/* toggle */}
          {/* <div className="terms w-full flex items-center justify-center space-x-9">
            <p className="monthly text-2xl font-meduim text-lightBlack tracking-tighter">
              Monthly
            </p>
            <div className="plan-toggle">
              <Toggle
                checked={billing === "yearly"}
                name="plans"
                background="plans"
                onChange={(e) =>
                  setBilling(e?.target?.checked ? "yearly" : "monthly")
                }
              />
            </div>
            <p className="yearly text-2xl font-meduim text-lightBlack tracking-tighter">
              Yearly
            </p>
          </div> */}
          <div className="relative flex items-center justify-between flex-col 2xs:flex-row gap-2">
            <div className="hidden 2xs:flex"></div>
            <div className="flex border rounded-full overflow-hidden bg-white border-[#d8d8d8] py-1 px-1">
              {termOption.map((option) => (
                <button
                  key={option}
                  onClick={() => setBilling(option)}
                  className={`px-4 py-2 font-medium transition-colors duration-200 capitalize rounded-full text-xs font-semibold ${
                    billing === option
                      ? 'bg-[#deeeff] text-[#0d6ed1] '
                      : 'text-[#bababa] hover:text-[#0d6ed1]'
                  }`}
                >
                  {option} 
                </button>
              ))}
            </div>
            <div className="">
              <CurrencySelector setCurrency={setCurrency} ></CurrencySelector>
            </div>
          </div>
          {/* plans */}
          <div className="plan-card w-full mt-15 space-y-11 md:flex md:flex-col md:items-center lg:flex-row lg:justify-center lg:items-stretch lg:space-x-11 lg:space-y-0">
            {PLANS.filter(
              (plan) => plan.term === billing.replace("ly", "") || plan.term === billing.replace("ily", "y") || !plan.term
            ).map((plan, index) => (
              <div key={index} className="">
                <PlanCardItem
                  obj={plan}
                  isFreeAccount={plan.plan === "Free Account"}
                  billing={billing}
                  currencyPrice={currencyPrice}
                  onCheckout={selectPlan}
                />
              </div>
            ))}
          </div>
        </div>
        {/* footer */}
        <div className="payment-method w-full mt-28">
          <h1 className="payment-heading text-5xl text-center font-bold tracking-tighter text-lightBlack">
            What payment methods we accept
          </h1>
          <div className="payment-items w-full flex justify-center">
            <img
              src={AcceptedPayments}
              alt="milestones-page-accepted-payments"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
